import styled from 'styled-components'
import { Box, Flex } from 'vvs-uikit'

export const QuestDetailContent = styled(Box)`
  flex: 1;
  width: 100%;
  background: ${({ theme }) => theme.colors.paleYellow};
`

export const TabItem = styled(Flex)`
  flex-direction: column;
  align-items: center;
  padding-top: 18px;
`
export const TabContent = styled(Box)`
  padding: 32px 15px 15px 15px;
`
